"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Course = void 0;
var typeorm_1 = require("typeorm");
var Module_1 = require("./Module");
var Units_1 = require("./Units");
var CourseType;
(function (CourseType) {
  CourseType["PRECOURSE"] = "PRECOURSE";
  CourseType["COURSE"] = "COURSE";
  CourseType["OTHER"] = "OTHER";
})(CourseType || (CourseType = {}));
var Month;
(function (Month) {
  Month["JANUARY"] = "JANUARY";
  Month["FEBRUARY"] = "FEBRUARY";
  Month["MARCH"] = "MARCH";
  Month["APRIL"] = "APRIL";
  Month["MAY"] = "MAY";
  Month["JUNE"] = "JUNE";
  Month["JULY"] = "JULY";
  Month["AUGUST"] = "AUGUST";
  Month["SEPTEMBER"] = "SEPTEMBER";
  Month["OCTOBER"] = "OCTOBER";
  Month["NOVEMBER"] = "NOVEMBER";
  Month["DECEMBER"] = "DECEMBER";
  Month["DEFAULT"] = "";
})(Month || (Month = {}));
var Course = /** @class */function () {
  function Course() {}
  __decorate([(0, typeorm_1.PrimaryGeneratedColumn)("uuid"), __metadata("design:type", String)], Course.prototype, "id", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: false
  }), __metadata("design:type", String)], Course.prototype, "title", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], Course.prototype, "description", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: false
  }), __metadata("design:type", Date)], Course.prototype, "startDate", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: false
  }), __metadata("design:type", Date)], Course.prototype, "endDate", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: false
  }), __metadata("design:type", String)], Course.prototype, "courseType", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: false,
    default: Month.DEFAULT
  }), __metadata("design:type", String)], Course.prototype, "month", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: null
  }), __metadata("design:type", Number)], Course.prototype, "year", void 0);
  __decorate([(0, typeorm_1.ManyToMany)(function () {
    return Module_1.Module;
  }), (0, typeorm_1.JoinTable)({
    name: "course_module_m2m"
  }), __metadata("design:type", Array)], Course.prototype, "modules", void 0);
  __decorate([(0, typeorm_1.ManyToOne)(function () {
    return Units_1.Unit;
  }), (0, typeorm_1.JoinColumn)(), __metadata("design:type", Units_1.Unit)], Course.prototype, "unit", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: null
  }), __metadata("design:type", String)], Course.prototype, "notificationMessage", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: null
  }), __metadata("design:type", String)], Course.prototype, "discordLink", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: null
  }), __metadata("design:type", String)], Course.prototype, "meetingLink", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: null
  }), __metadata("design:type", Date)], Course.prototype, "meetingDate", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: null
  }), __metadata("design:type", String)], Course.prototype, "calendlyLink", void 0);
  __decorate([(0, typeorm_1.CreateDateColumn)(), __metadata("design:type", Date)], Course.prototype, "created_at", void 0);
  __decorate([(0, typeorm_1.UpdateDateColumn)(), __metadata("design:type", Date)], Course.prototype, "updated_at", void 0);
  Course = __decorate([(0, typeorm_1.Entity)()], Course);
  return Course;
}();
exports.Course = Course;